import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { take } from 'rxjs';
import { slideInOut } from '../../animations/slide-in-out.animation';
import { getWindow } from 'ssr-window';

@Component({
  selector: 'a-select',
  templateUrl: 'a-select.component.html',
  styleUrls: ['a-select.component.scss'],
  animations: [slideInOut]
})
export class ASelectComponent {

  @ViewChild('scrolledEl') scrolledEl: ElementRef | undefined;
  @ViewChild('selectEl') selectEl: ElementRef | undefined;
  @Output() dropSkills = new EventEmitter<boolean>();
  @Output() onValueChanged = new EventEmitter<boolean>();
  @Output() onBlur = new EventEmitter<any>();
  @Output() onFocused = new EventEmitter<any>();
  @Input() isSubmitted = true;
  @Input() label = '';
  @Input() grayBg = true;
  @Input() isOptional = false;
  @Input() isDisabled = false;
  @Input() enableSearch = true;
  @Input() useLables = false;
  @Input() hasMeta = false;
  @Input() hasClear = false;
  @Input() valueKey = 'value';
  @Input() control: FormControl = new FormControl();
  @Input() set jobTitleWarnity(val) {
    if (val) { this.enableJobTitleWarnity = true; };
  };
  @Input() set items(vals) {
    if (vals) { this.setValues(vals); }
  }

  enableJobTitleWarnity = false
  showItems = false;
  inputFocused = false;
  openPositionTop = false;
  savedValue = null;
  searchValue = '';
  allItems = null;
  shadowItems = null;
  selectedItem = null;

  constructor() {
  }

  onFocus(val: boolean) {
    if (this.isDisabled) {
      this.inputFocused = false;
      this.showItems = false;
      this.searchValue = this.control.value || '';
      return;
    }

    this.inputFocused = val;
    if (this.inputFocused) {
      this.searchValue = '';
      this.showDropdown(null);
      this.shadowItems = this.allItems;
    } else {
      this.searchValue = this.control.value;
    }
  }

  showDropdown(e, val: boolean = true) {
    if (this.isDisabled) {
      this.showItems = false;
      return;
    }

    if (e && e.target && e.target.className && e.target.className.includes('app-ico-mask__x')) {
      return;
    }
    setTimeout(() => this.showItems = val, 1)
    if (this.selectEl) {
      const position = this.selectEl.nativeElement.getBoundingClientRect().top;
      this.openPositionTop = getWindow().innerHeight - position < 240;
    }
    if (val) {
      this.onFocused.emit();
      if (this.selectedItem) {
        const id = this.allItems.findIndex((item: any) => {
          return item.code ? item.code === this.selectedItem.code : item[this.valueKey] === this.selectedItem[this.valueKey];
        });
        setTimeout(() => {
          const el = document.getElementById('a-select-item-id-' + id);
          if (this.scrolledEl && el) {
            this.scrolledEl.nativeElement.scrollTop = el.offsetTop - 45;
          }
        });
      }
    }
  }

  selectItem(val: any, enableJobTitleWarnity = false, withLoader = false, closeDropdown = true, force = false) {
    if (this.isDisabled && !force) {
      return;
    }

    if (this.selectedItem !== val && enableJobTitleWarnity) {
      this.savedValue = val;
      return;
    } 
    if (val) {
      this.searchValue = val[this.valueKey];
      this.selectedItem = val;
      if (this.selectedItem && this.control.value !== val[this.valueKey]) {
        this.control.setValue(val[this.valueKey]);
        this.onValueChanged.emit(val);
        if (withLoader) {
          this.onBlur.emit();
        }
      }
      if (closeDropdown) {
        this.showDropdown(null, false);
      }
    }
  }

  clearConfirm(result) {
    if (result) {
      this.selectItem(this.savedValue, false);
      this.enableJobTitleWarnity = false;
      const isCustomJobTitle = this.selectedItem && this.selectedItem.isCustomJobTitle
      this.dropSkills.emit(isCustomJobTitle);
    }
    this.savedValue = null;
  }

  clear() {
    if (this.isDisabled) {
      return;
    }

    this.selectedItem = null;
    this.searchValue = '';
    this.showDropdown(null, false);
    this.control.setValue(null);
    this.onValueChanged.emit(null);
  }

  findResult(val: any) {
    if (this.isDisabled) {
      return;
    }

    this.shadowItems = this.allItems.filter((item: any) => item[this.valueKey].toLowerCase().includes(val.toLowerCase()));
  }

  private setValues(vals = this.allItems) {
    setTimeout(() => {
      this.shadowItems = this.allItems = vals;
      const selectedValue = this.control.value;
      if (selectedValue) {
        const currentValue = this.shadowItems.find(item => JSON.stringify(item[this.valueKey]) === JSON.stringify(selectedValue));
        this.selectItem(currentValue, false, false, false, true);
      } else {
        this.selectedItem = null;
        this.control.valueChanges.pipe(take(1)).subscribe(val => {
          const foundValue = this.shadowItems.find(item => JSON.stringify(item[this.valueKey]) === JSON.stringify(val));
          if (foundValue) {
            this.selectItem(foundValue, false, false, false, true);
          }
        });
      }
    })
  }
}
